export function getPercentageDiff(a: number, b: number) {
  if (a === 0 && b === 0) return 0;

  if (b === 0) return a > 0 ? 100 : -100;

  const diff = ((a - b) / b) * 100;
  return Math.round(diff * 100) / 100;
}

export function addDowntimeHours(data: any[]) {
  return data.map((item) => {
    const dateOfOrder = item.date_of_orders;
    const dateOfCompletion = item.date_of_completion;
    let downtimeHours = 0;

    if (dateOfOrder && dateOfCompletion) {
      const diffInMs =
        new Date(dateOfCompletion).getTime() - new Date(dateOfOrder).getTime();
      downtimeHours = diffInMs > 0 ? diffInMs / (1000 * 60 * 60) : 0; // Convert ms to hours
    }

    return {
      ...item,
      downtimeHours: Math.round(downtimeHours * 100) / 100,
    };
  });
}
export const capitalizeWords = (s = '') =>
  s.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
